import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Megaphone } from 'lucide-react';
import type { FilterState } from '../GlobalFilters';

interface AdsTabProps {
  clientId: string;
  filters: FilterState;
}

export function AdsTab({ clientId, filters }: AdsTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Megaphone className="mr-2 h-5 w-5" />
          Publicité Amazon Ads
        </CardTitle>
        <CardDescription>Performance des campagnes publicitaires</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">Données publicitaires en cours de chargement...</p>
      </CardContent>
    </Card>
  );
}